import { Controller } from "@hotwired/stimulus"

// Toggles the confirmation page's account card between "create account" and
// "log in". Classic JS only (old Babel — no ?./??). Ported from the mock's
// inline toLogin/toCreate listeners.
export default class extends Controller {
  static targets = ["createForm", "loginForm", "title", "desc"]

  showLogin(event) {
    event.preventDefault()
    this.createFormTarget.style.display = "none"
    this.loginFormTarget.style.display = "flex"
    this.titleTarget.textContent = "Connectez-vous"
    this.descTarget.textContent = "Retrouvez votre commande et toutes vos box dans votre espace Kube."
  }

  showCreate(event) {
    event.preventDefault()
    this.loginFormTarget.style.display = "none"
    this.createFormTarget.style.display = "flex"
    this.titleTarget.textContent = "Créez votre compte Kube"
    this.descTarget.textContent = "Pour suivre votre commande, gérer vos adresses et retrouver toutes vos box — votre email est déjà renseigné."
  }
}
